
//const App = {
//template: "<div>Hemlo Domst</div>"
//}

/*
tbd
- styling the comments section -- done
- pagination in user posts -- done
- just previews in userposts but full post and comments on clicking 'more' -- done
- a feed -- done
- fab Add icon in UserPosts to add new posts
- loading icon when login is clicked, till actual login happens, similar for add post
- back button in comments section to back to all posts
- a profile section (with that name, with username, and all in the hero section)
- all posts one liner, and click to load the full post and comments (to make it all aligned)
- image support
- chat
*/


import { createApp } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'
import UserPosts from './components/UserPosts.vue'
import CreateAcc from './components/CreateAcc.vue'
import LogIn from './components/LogIn.vue'
import App from './App.vue'
import HomeComponent from './components/HomeComponent.vue'
import CreatePost from './components/CreatePost'
import PostView from './components/PostView'
import FeedView from './components/FeedView'
import './assets/tailwind.css'

/*
const App = {
    template: "<div>Hemlo Domst</div>"
}
*/

const routes = [
  {path: '/', name: "home", component: HomeComponent},
  {path: '/create-post/:id', name: "create-post", component: CreatePost, props: true},
  {path: '/posts/:id', name: "posts", component: UserPosts, props: true},
  {path: '/post/:postuser', name: "post", component: PostView, props: true},
  {path: '/feed/:id', name: "feed", component: FeedView, props: true},
  {path: '/create-account', name: "create-account", component: CreateAcc},// props: true},
  {path: '/login', name: "login", component: LogIn}
]
const router = createRouter({
  history: createWebHashHistory(),
  routes
})



const app = createApp(App)


app.use(router)
app.mount('#app')
